"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var colors = {
  debug: 'DEBUG',
  success: 'SUCCES',
  info: 'INFO',
  warn: 'WARNING',
  error: 'ERROR'
};
var formatLog = function formatLog(level, message, data, moduleName) {
  var suffix = moduleName || 'Generic';

  /* eslint no-console: "off" */
  return console.log("[ ".concat(colors[level], " ] Systems SDK | ").concat(suffix, "  message : { ").concat(message, " }"), "", data);
};
var _default = exports["default"] = {
  success: function success(message, data, suffix) {
    formatLog('success', message, data, suffix);
  },
  info: function info(message, data, suffix) {
    formatLog('info', message, data, suffix);
  },
  warn: function warn(message, data, suffix) {
    formatLog('warn', message, data, suffix);
  },
  error: function error(message, data, suffix) {
    formatLog('error', message, data, suffix);
  },
  debug: function debug(message, data, suffix) {
    formatLog('debug', message, data, suffix);
  }
};